import {
  DataBlockTypeDto,
  DataBlockWithValuesDto,
  DataType,
} from '@lmt/shared-types';
import { createContext } from 'use-context-selector';

export type UIEditorField = {
  key: string;
  type: DataType;
  dataBlockFieldId: number;
  // for hardcoded fields we pass dictionaryTitle via this prop
  dataBlockDictionaryTitle?: string | null | undefined;
  isOptionAllowed?: boolean;
  isSingleValue?: boolean;
  isRequired?: boolean;
};

export type FieldBlockConfiguration = {
  title: string;
  fields: UIEditorField[];
  dataBlockTypeId: number;
  isModificationAllowed: boolean;
  isShared: boolean;
};
export type ToolbarComponentProps = {
  setIsLoading: (isLoading: boolean) => void;
  setConfigKey: (configKey: string) => void;
};
export type ToolbarComponentType = React.FC<ToolbarComponentProps>;

export type UIEditorData = Record<string, UIEditorDataObjectValue>;
export type UIEditorDataObjectValue =
  | string
  | number
  | Date
  | unknown
  | undefined
  | null;

export interface UIEditorContextInterface {
  isOnlyView: boolean;
  dataBlockTypeName: string;
  dataBlockType: DataBlockTypeDto | undefined;
  dataBlock: DataBlockWithValuesDto | undefined;
  values?: UIEditorData;
  setValues?: (key: string, value: UIEditorDataObjectValue) => void;
  errors?: { [key: string]: string };
  setErrors?: (key: string, error: string) => void;
  sharedValues?: UIEditorData;
  setSharedValues?: (key: string, value: UIEditorDataObjectValue) => void;
  showErrors: boolean;
}

const defaultValues: UIEditorContextInterface = {
  isOnlyView: false,
  dataBlockTypeName: '',
  dataBlockType: undefined,
  dataBlock: undefined,
  values: undefined,
  setValues: undefined,
  errors: undefined,
  setErrors: undefined,
  sharedValues: undefined,
  setSharedValues: undefined,
  showErrors: false,
};
export const InputValuesContext = createContext(defaultValues);
